<template>
  <div class="flex flex-col border-b-2 border-qwraysuperlight">
    <div
      class="text-white font-bold font-20px cursor-pointer font-Foco"
      v-bind:class="active ? 'text-qwellow' : 'text-white'"
      @click="activated()"
    >
      {{ $t(header) }}
    </div>
    <div
      class="mt-5 text-16px text-white ml-10 fade"
      v-bind:class="active ? '' : 'hidden'"
    >
      {{ $t(text) }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ['header', 'text', 'active'],
  methods: {
    activated() {
      this.$emit('activated');
    },
  },
};
</script>

<style scoped></style>
